var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg403ForbiddenIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #deeff9;\n      }\n\n      .cls-2 {\n        fill: #ced627;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #c59d72;\n      }\n\n      .cls-5 {\n        fill: #e7b63b;\n      }\n\n      .cls-6 {\n        fill: #58afe2;\n      }\n\n      .cls-7 {\n        fill: #f2f2f2;\n      }\n\n      .cls-8 {\n        fill: #a5845f;\n      }\n\n      .cls-9 {\n        fill: #d32626;\n      }\n\n      .cls-10 {\n        fill: #ffc841;\n      }\n\n      .cls-11 {\n        fill: #e95c2b;\n      }\n\n      .cls-12 {\n        fill: #ccc;\n      }\n\n      .cls-13 {\n        fill: #bd9671;\n      }\n\n      .cls-14 {\n        fill: #4e3a22;\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-16 {\n        fill: #fdca2b;\n      }\n\n      .cls-17 {\n        fill: #e6e6e6;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M432.33,198.93c1.06,20.07-6.72,20.07-16.9,20.07-4.99,0-9.61-.1-13.12-3.04-1.09-.91-6.84-3.96-4.84-15.97,1.06-6.34,2.11-14.79,2.47-24.82h31.68c.58,8.27.26,15.48.7,23.76Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M153.99,187.6h369.99v258.26c0,5.52-4.48,10-10,10H163.99c-5.52,0-10-4.48-10-10V187.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M163.71,136.17h350.7c5.52,0,10,4.48,10,10v41.97H153.71v-41.97c0-5.52,4.48-10,10-10Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 187.42,
    cy: 165.8,
    r: 9.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 215.51,
    cy: 165.8,
    r: 9.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 244.07,
    cy: 165.8,
    r: 9.36
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M432.33,198.93c1.06,20.07-6.72,20.07-16.9,20.07-4.99,0-9.61-.1-13.12-3.04-1.09-.91-6.84-3.96-4.84-15.97,1.06-6.34,2.11-14.79,2.47-24.82h31.68c.58,8.27.26,15.48.7,23.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 414.5,
    cy: 171,
    rx: 36.5,
    ry: 27
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M412.14,79.07c-20.04-.04-32.02,17.47-33.52,19.75-14.74,22.32-13.9,63.48,10.18,82.25,2.12,1.65,13.78,10.35,29.85,9.05,1.11-.09,15.47-1.46,26.49-12.27,19.86-19.49,17.52-58.66-1.03-81.73-3.2-3.98-14.71-17.01-31.98-17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.77,156.89c-1.85,2.13-7.38,1.24-8.4-1.36-1.24-3.16,0-6.23.34-9.34.09-.84-.16-2.07,1.05-2.12,0,0,.47-.04.95.23.63.36.56,2.64-.18,5.57-.14.42-1.09,3.4.37,4.81.56.55,1.33.7,2.29.89,2.19.43,3.7-.12,3.94.42.15.33-.28.81-.36.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.79,166.21c-3.68-2.38-10.09,0-11.94,4.94,4.14-1.93,7.62-4.4,11.93-2.57.44.19,1.05.02,1.19-.56.24-.98-.53-1.39-1.18-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.43,129.5c3.66-2.92,7.68-1.47,12.18-.72-3.1-4.26-9.92-4.84-12.82-1.57-.51.58-1.15,1.19-.66,2.06.29.52.93.52,1.3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9,130.89c.4.25,1.03.18,1.27-.37.39-.93-.31-1.46-.89-1.98-3.26-2.92-9.97-1.57-12.56,3.02,4.39-1.26,8.21-3.16,12.18-.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.81,
    cy: 136.9,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.19,
    cy: 135.05,
    r: 3.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M456.29,100.45c-.51,4.25-1.68,8.59-4.67,11.62-2.28,2.3-5.31,3.53-8.53,4.04-2.15.39-4.37.43-6.49.25-10.23-.83-19.69-5.68-29.7-7.97-9.98-2.29-22.09-1.29-28.22,6.95-1.76,2.39-2.95,5.29-5.15,7.28-1.2,1.06-2.85,1.73-4.41,1.82-2.24-10.66-1.73-21.26,3.08-29.85,5.85-10.46,19.31-19.96,34.46-19.47,7.82.25,15,3.15,20.75,7.31.12.05.25.11.37.16,6.07,2.91,14.42,4.14,18.61-1.1,1.83-2.27,3.91-5.89,6.46-4.5,4.03,1.4,4.38,15.5,3.45,23.45Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 370.31,
    cy: 134.81,
    rx: 7.85,
    ry: 11.26,
    transform: "translate(-7.1 21.4) rotate(-3.28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 456.15,
    cy: 129.89,
    rx: 7.85,
    ry: 11.26,
    transform: "translate(-6.68 26.3) rotate(-3.28)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M407.61,354.17l-106.74-41.2c-6.05-2.33-8.58-9.51-5.35-15.13l39.64-68.81,27.45,15.82-27.33,47.44,83.73,32.32-11.41,29.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M419.95,345.35l-6.94-30.92,90.06-20.2-22.63-32.68,26.05-18.04,40.49,58.46c4.27,6.16.94,14.68-6.37,16.32l-120.65,27.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 429.16,
    y: 654.12,
    width: 31.68,
    height: 54.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 292.66,
    y: 653.98,
    width: 44.86,
    height: 31.68,
    transform: "translate(-402.08 853.12) rotate(-79.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M492.46,292.77l37.01-21.82c1.12-.66,1.38-2.16.55-3.17l-43.9-53.04c-4.41-5.33-12.13-9.74-19.13-10.74l-34.67-5.07c1.5,13.5-8.94,20.53-18.29,19.89-7.75-.53-15.47-8.51-15.98-19.21-11.68,1.46-23.37,2.92-35.05,4.39-3.77.34-9.14,1.29-15,4-9.69,4.49-15.37,11.33-18,15-8.02,12.01-23.5,34.69-27.53,41.53-.6,1.02-.18,2.34.9,2.83l38.64,17.49c.93.4,2.01.09,2.58-.74l17.5-25.5-3.17,47.53,114.06-2.11,5.81-36.44,10.66,24.23c.51,1.16,1.92,1.61,3.01.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.83,263.35l4.9-60.2c-1.52-1.02-4.02-2.42-7.39-3.17-4.13-.92-7.59-.42-9.51,0-.84,20.45-1.68,40.9-2.53,61.34-.05,1.13-.98,2.03-2.11,2.03h-44.37c-1.07,0-1.98-.8-2.1-1.87l-6.98-60.44c-2.22-.67-5.95-1.48-10.56-1.06-4.83.45-8.48,2.06-10.56,3.17,4.23,21.86,8.47,43.73,12.7,65.59.12.63,0,1.29-.34,1.84l-11.69,18.59c-4.56,7.25-6.76,15.74-6.31,24.29l2.81,52.84-86.41,290.46,62.31,10.56,85.55-301.02,4.91,312.11h60.05l-9.21-370.48c-.19-7.74-2.54-15.27-6.79-21.74l-16.36-22.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.35,724.88h-97.69v-36.96c5.01,3.13,12.64,6.86,22.18,7.39,16.33.91,21.4-8.52,38.55-7.39,3.78.25,16.56,1.27,26.14,10.83,6.32,6.3,8.76,13.84,9.16,15.14,1.38,4.43,1.66,8.31,1.66,10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,696.96l95.78,19.21,7.27-36.24c-5.53,2.08-13.74,4.24-23.2,2.89-16.19-2.32-19.31-12.57-36.34-14.83-3.75-.5-16.49-2.01-27.76,5.47-7.44,4.94-11.31,11.85-11.96,13.05-2.22,4.07-3.27,7.82-3.79,10.45Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.81,290.56h369.99v258.26c0,5.52-4.48,10-10,10h-349.99c-5.52,0-10-4.48-10-10v-258.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.3,238.62h350.7c5.52,0,10,4.48,10,10v41.97h-370.7v-41.97c0-5.52,4.48-10,10-10Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 368.02,
    cy: 268.24,
    r: 9.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 379.16,
    y: 479.79,
    width: 281.04,
    height: 45.44,
    rx: 7.73,
    ry: 7.73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 614.59,
    y: 480.07,
    width: 45.44,
    height: 45.44,
    rx: 7.73,
    ry: 7.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M635.53,490.58l8.38,10.73c.59.78.98,1.43.98,2.34,0,.85-.39,1.49-.98,2.27l-8.19,10.53c-.65.91-1.75,1.56-2.93,1.56-1.82,0-3.18-1.49-3.18-3.25,0-.78.39-1.63.91-2.21l6.82-8.84-6.95-9.1c-.58-.72-.84-1.36-.84-2.21.06-1.82,1.43-3.25,3.25-3.25,1.23,0,2.15.65,2.73,1.43Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 407.84,
    cy: 504.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.26,
    cy: 504.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.67,
    cy: 504.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.08,
    cy: 504.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.49,
    cy: 504.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504.9,
    cy: 504.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.31,
    cy: 504.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543.72,
    cy: 504.4,
    r: 6.7
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 396.11,
    cy: 268.24,
    r: 9.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 424.67,
    cy: 268.24,
    r: 9.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M520.39,328.24c-3.16,3.71-10.17,10.93-21.61,15.23-11.43,4.3-14.82,3.58-20.64,2.6-2.7-.46-5.54.32-7.35,2.37-.22.25-.43.51-.64.79-1.23,1.71-1.94,3.8-1.94,6.01v50.29c0,2.75,1.11,5.39,3.07,7.32l45.69,33.47c3.25,3.19,8.46,3.18,11.68-.04l47.11-33.97c1.93-1.93,3.02-4.54,3.02-7.27v-49.81c0-2.27-.75-4.41-2.04-6.14-1.84-2.46-5.01-3.49-8.03-2.92-5.53,1.04-8.3,1.89-19.19-1.91-12.52-4.37-19.82-12.48-23.05-16.13-.07-.11-1.09-1.64-2.98-1.66-2.01-.02-3.07,1.7-3.11,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M541.25,374.94h-3.44v-5.96c0-7.9-6.42-14.32-14.31-14.32s-14.32,6.43-14.32,14.32v5.96h0s-3.44,0-3.44,0c-2.08,0-3.77,1.69-3.77,3.79v27.71c0,2.09,1.69,3.79,3.77,3.79h35.51c2.08,0,3.77-1.69,3.77-3.79v-27.71c0-2.09-1.69-3.79-3.77-3.79ZM513.74,374.94v-5.96c0-5.38,4.38-9.76,9.76-9.76s9.75,4.38,9.75,9.76v5.96h0s-19.5,0-19.5,0h0ZM527.13,394.23c-.88.83-1.43,1.97-1.29,3.18,0,.08.01.17.01.26,0,1.3-1.05,2.35-2.35,2.35s-2.35-1.05-2.35-2.35c0-.09,0-.17.01-.26.13-1.21-.43-2.35-1.31-3.19-1.27-1.21-1.93-3.06-1.49-5.03.43-1.92,1.98-3.48,3.9-3.92,3.45-.79,6.52,1.81,6.52,5.13,0,1.51-.63,2.86-1.64,3.82Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.28,322.95l-11.39,84.23c-.3,2.19-2.31,3.72-4.5,3.43l-76.31-10.32c-2.19-.3-3.72-2.31-3.43-4.5l14.21-105.04c.3-2.19,2.31-3.72,4.5-3.43l55.49,7.51-3.08,22.79c-.15,1.09.62,2.1,1.71,2.25l22.79,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M282.35,322.46l-.07.5-22.79-3.08c-1.09-.15-1.86-1.16-1.71-2.25l3.08-22.79.5.07,20.99,27.56Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M249.12,345.37l-2.43-.33h0s.57-4.21.57-4.21c.75-5.57-3.16-10.72-8.73-11.47s-10.72,3.17-11.47,8.74l-.57,4.21h0s-2.43-.33-2.43-.33c-1.47-.2-2.82.83-3.02,2.31l-2.64,19.55c-.2,1.48.83,2.83,2.3,3.03l25.06,3.39c1.47.2,2.82-.83,3.02-2.31l2.64-19.55c.2-1.48-.83-2.83-2.3-3.03ZM229.71,342.75l.57-4.21c.51-3.8,4.02-6.47,7.82-5.95s6.46,4.02,5.95,7.82l-.57,4.21h0s-13.76-1.86-13.76-1.86h0ZM237.32,357.64c-.7.5-1.19,1.26-1.22,2.12,0,.06,0,.12-.01.18-.12.92-.97,1.56-1.89,1.44s-1.56-.97-1.44-1.89c0-.06.02-.12.03-.18.21-.84-.08-1.7-.62-2.38-.78-.98-1.07-2.34-.57-3.69.49-1.31,1.73-2.27,3.12-2.39,2.51-.23,4.43,1.9,4.11,4.24-.14,1.06-.72,1.96-1.52,2.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M203.87,258.83l9.28,64.59c.43,3-1.65,5.78-4.65,6.21l-96.23,13.83c-2.98.43-5.76-1.65-6.19-4.65l-9.28-64.59c-.43-3,1.65-5.78,4.63-6.21l96.23-13.83c3-.43,5.78,1.65,6.21,4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.64,254.93l.97,6.73-44.18,6.35c-2.98.43-5.06,3.21-4.63,6.21l-1.75-12.17c-.38-2.64,1.45-5.11,4.09-5.49l40.02-5.75c2.64-.38,5.11,1.47,5.49,4.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168.52,290.08l-2.78.4h0s-.69-4.81-.69-4.81c-.91-6.38-6.84-10.83-13.21-9.92-6.38.91-10.83,6.84-9.92,13.22l.69,4.81h0s-2.78.4-2.78.4c-1.68.24-2.85,1.8-2.61,3.49l3.19,22.38c.24,1.69,1.8,2.86,3.48,2.62l28.68-4.09c1.68-.24,2.85-1.8,2.61-3.49l-3.19-22.38c-.24-1.69-1.8-2.86-3.48-2.62ZM146.3,293.25l-.69-4.81c-.62-4.35,2.41-8.39,6.76-9.01s8.38,2.41,9,6.76l.69,4.81h0s-15.75,2.25-15.75,2.25h0ZM159.34,307.3c-.61.77-.92,1.76-.68,2.71.02.07.03.14.04.21.15,1.05-.58,2.02-1.63,2.17s-2.02-.58-2.17-1.63c0-.07-.02-.14-.02-.21-.03-.99-.62-1.85-1.42-2.43-1.16-.83-1.91-2.25-1.78-3.89.12-1.6,1.2-3.04,2.7-3.61,2.7-1.03,5.47.71,5.86,3.39.17,1.22-.18,2.39-.89,3.28Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403ForbiddenIllustration);
export default __webpack_public_path__ + "static/media/403-forbidden-illustration.d1d11e42dbe60fd858111ae6d23e158e.svg";
export { ForwardRef as ReactComponent };